var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAirpod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88 22.75c-4.03 0-6.44-.79-6.88-4.84-.08-.58-.12-1.27-.12-2.16v-7.5c0-.86.04-1.57.12-2.17.46-4.06 2.77-4.83 6.89-4.83h6.25c4.12 0 6.44.77 6.88 4.85.1.67.12 1.43.12 2.15v7.5c0 .87-.04 1.56-.12 2.18-.46 4.05-2.78 4.82-6.9 4.82H8.88zM3.48 6.26c-.08.55-.11 1.2-.11 1.99v7.5c0 .82.04 1.44.11 1.97.29 2.61 1.14 3.53 5.4 3.53h6.24c4.25 0 5.11-.92 5.4-3.5.07-.55.11-1.2.11-2v-7.5c0-.66-.01-1.36-.1-1.96-.29-2.62-1.14-3.54-5.4-3.54H8.88c-4.25 0-5.11.92-5.4 3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.13 9.67c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.1c.41 0 .75.34.75.75s-.34.75-.75.75h-4.1zM2.77 9.67c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.1c.41 0 .75.34.75.75s-.34.75-.75.75h-4.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92 11.72c-.75 0-1.47-.3-1.99-.84a2.71 2.71 0 0 1-.81-1.96c0-1.54 1.26-2.8 2.8-2.8h6.15c.75 0 1.47.31 1.99.84.52.51.82 1.21.82 1.96 0 1.54-1.26 2.8-2.8 2.8H8.92zm-1.3-2.8c0 .35.13.67.37.9.25.26.58.4.93.4h6.16c.72 0 1.3-.58 1.3-1.3 0-.34-.14-.66-.38-.9-.25-.26-.58-.4-.93-.4H8.92c-.72 0-1.3.58-1.3 1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAirpod);
export default __webpack_public_path__ + "static/media/vuesax-outline-airpod.0545248ff58955ecc0130122b089e890.svg";
export { ForwardRef as ReactComponent };